import React from 'react';
import Modal from 'react-responsive-modal';
import _ from 'lodash';
import Translate from 'translate';

class TokenModal extends React.Component {
  constructor( props ) {
    super( props );
  }

  render() {
    const { data, onClose, open } = this.props;

    return (
      <Modal little
             modalClassName="col-md-6 client-folder p-0"
             open={open}
             onClose={onClose}>

        <div className="p-3 mb-4 bg-blue">
        <h5 className="m-0 d-inline-block"><Translate id="token"/> {_.get( data, 'DocNumber' )}</h5>
        </div>

        <div className="row mb-3 px-3">
          <div className="col-md">
            <p className="mb-1"><Translate id="date"/>: {_.get( data, 'DateTimeToken', '-' )}</p>
            <p className="m-0"><Translate id="collectionCenter"/>: {_.get( data, 'CollCenterToken', '-' )}</p>
          </div>
          <div className="col-md">
            <p className="mb-1"><Translate id="energyToken"/>: {_.get( data, 'EnergyToken', '-' )}</p>
            <p className="m-0"><Translate id="token"/>: {_.get( data, 'Token' ) ? data.Token.match(/.{1,4}/g).join('.') : '-'}</p>
          </div>
        </div>
      </Modal>
    )
  }
}

module.exports = TokenModal;



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/TokenModal/index.js